import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import { SpotlightModal } from "./components/SpotlightModal";
import Dashboard from "./components/Dashboard";
import KnowledgeArticle from "./components/KnowledgeArticle";
import KnowledgeSearch from "./components/KnowledgeSearch";
import WikiPage from "./components/WikiPage";

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/" />;
};

const App: React.FC = () => {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/index.html" element={<Dashboard />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          
          {/* Wiki routes */}
          <Route path="/wiki/:id" element={<WikiPage />} />
          
          {/* Knowledgebase routes */}
          <Route path="/k/search" element={<KnowledgeSearch />} />
          <Route path="/k/:slug" element={<KnowledgeArticle />} />
        </Routes>
        {/* Add SpotlightModal for displaying spotlight notifications */}
        <SpotlightModal />
      </Router>
  );
};

export default App;
